<template minapp='mpx' xlang ='wxml'>
  <view class="train-agreement">
    <!-- 时间范围选择 -->
    <view class="picker-content" wx:style="{{{marginTop: pickerMargin}}}">
      <view slot="left">
        <view class="picker-left">时间选择</view>
      </view>
      <view slot="right">
        <view class="picker-right" bindtap="pickerToggle">
        <text>{{currentPickerLable}}</text>
        <es-icon name="{{pickerOpen == true ? 'angle-top' : 'angle-down'}}" color="#999" size='14' />
      </view>
      </view>
    </view>
     <view class="picker-select" wx:if="{{pickerOpen == true}}">
      <view 
        class="item" 
        wx:for="{{pickerSelectOptions}}" 
        wx:key="index"
      >
        <text 
          class="{{item.label == currentPickerLable ? 'active-text' : ''}}"
          bindtap="pickerSelect(item)"
        >{{item.label}}</text>
      </view>
    </view>
    <!-- 遮罩层 -->
    <view class="picker-overlay" wx:show="{{overlayShow}}">
    </view>
    <!-- 内容主体 -->
    <view 
      class="agreement-content"
      wx:for="{{personalInfoChecklist}}"
      wx:key="index"
    >
    <view class="title">
      <view class="title-left">{{item.title}}</view>
      <view class="title-right" bindtap="contentToggle(index)">
        <text>{{item.show == true ? '点击收起' : '点击展开'}}</text>
        <es-icon name="{{item.show == true ? 'angle-top' : 'angle-down'}}" color="#999" size='14' />
      </view>
    </view>
    <view 
      class="content" 
      wx:if="{{item.show == true}}" 
      wx:for="{{item.sub_group}}" 
      wx:for-item="subItem"
      wx:key="index"
    >
      <view class="subtitle">{{subItem.subtitle}}</view>
      <view class="content-item" wx:for="{{subItem.text_list}}" wx:for-item="textItem">
        {{textItem.key}}：
        <text 
          class="{{textItem.jump_url ? 'go-order' : ''}}"
          bindtap="jumpToOrder(textItem.jump_url)"
        >{{textItem.value}}</text>
      </view>
    </view>
    </view>
   </view>
  </view>
</template>


<script>
  import { createPage, mpx } from '@didi/es-mpx-creator'
  import store from '@/store'
  import { cloneDeep } from 'lodash'
  import { innerRouter, pagePath, closePage } from "@/common/jump";
  import { isWXMini, isALIMini } from '@/common/constant'
  createPage({
    data: {
      pickerOpen: false,
      currentPickerLable: '历史所有',
      overlayShow: false
    },
    mounted() {
      this.getList();  
    },
    computed: {
      ...store.mapState({
        personalInfoChecklist: 'agreement.personalInfoChecklist',
        pickerSelectOptions: 'agreement.pickerSelectOptions'
      }),
      currentPickerKey() {
        const currentItem = this.pickerSelectOptions.find(item => item.label == this.currentPickerLable);
        const { key = 'all' } = currentItem;
        return key;
      },
      isMiniH5(){
        return isWXMini || isALIMini
      },
      pickerMargin() {
        return this.isMiniH5 ? '0px' : '10px'
      }
    },
    methods: {
      ...store.mapActions({
        getPersonalInfoChecklistAction: 'agreement.getPersonalInfoChecklistAction'
      }),
      ...store.mapMutations({
        setPersonalInfoChecklist: 'agreement.setPersonalInfoChecklist'
      }),
      async getList() {
        mpx.showLoading()
        await this.getPersonalInfoChecklistAction({
          time_type: this.currentPickerKey
        });
        mpx.hideLoading();
      },
      jumpToOrder(url) {
        if(url) {
          innerRouter.push(url);
        }
      },
      goPage(type) {
        if(type == 'back') return;
      },
      homeBack() {
        closePage()
      },
      pickerToggle() {
        this.pickerOpen = !this.pickerOpen;
        this.overlayShow = !this.overlayShow;
      },
      pickerSelect(item) {
        this.currentPickerLable = item.label;
        this.pickerToggle();
        this.getList();
      },
      contentToggle(index) {
        let data = cloneDeep(this.personalInfoChecklist);
        data[index].show = !data[index].show;
        this.setPersonalInfoChecklist({data});
      }
    }
  })
</script>

<style lang='stylus' scoped>
  .train-agreement
    position relative
    height 100%
    overflow-y scroll
    background-color rgb(243, 244, 245)
    .es-header
      margin-bottom 10px
    .es-navbar__title
      font-size 16px
    .agreement-content
      padding 16px
      background-color #fff
      margin-top 12px
      .title 
        display flex
        justify-content space-between
        align-items center
        .title-left
          font-family PingFangSC-Medium
          font-size 15px
          color #000
          font-weight 700
        .title-right
          font-size 12px
          color #999
          display flex 
          align-items center  
      .content 
        &:not(:last-child)
          padding-bottom 16px
          border-bottom 1px solid #ecedf0
        .subtitle
          margin 16px 0 4.5px 0
          color #444
          font-size 14px 
          font-weight 700
        .content-item
          font-size 12px
          color #999
          .go-order
            color #ff7c46
    .picker-overlay
      width 100%
      height 100%
      min-height 100vh
      background rgba(0,0,0,.4)
      position fixed
      top 55px
      left 0
      right 0
      bottom 0
      z-index 999
    .picker-content
      height 25px
      background-color #fff
      display flex
      justify-content space-between
      align-items center
      padding 15px
      .picker-left
        font-family PingFangSC-Medium
        font-size 15px
        color #000
        font-weight 700
      .picker-right
        font-size 12px
        color #999
        display flex 
        align-items center  
    .picker-select
      position fixed
      z-index 1000
      width 100%
      background-color #fff
      border-top 1px solid #f3f4f5
      left 0
      top 55px
      .item
        padding 16px
        border-bottom 1px solid #f3f4f5
        display flex
        justify-content center
        align-items center
        span 
          font-family PingFangSC-Medium
          font-size 14px
          color #757575
          font-weight 500
          text-align center
        .active-text
          color #ea5e1e
</style> 

<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      'es-navbar': '../../es-mpx-ui/lib/navbar'
    }
  }
</script>